module.exports = __webpack_public_path__ + "img/nova_avia_logo.fe495d64.png";